type TLink = {
  name: string
  href: string
  icon?: string
}

type TLinkColumn = {
  name: string
  children: TLink[]
}

type TSectionWithColumns = {
  name: string
  columns: TLinkColumn[]
}

type TSectionWithChildren = {
  name: string
  children: TLink[]
}

export type TPopoverMenu = {
  name: string
  menuId: string
  sections: TSectionWithColumns[] | TSectionWithChildren[]
  extraClass?: string
}

export function useWwwNavigation() {
  const $config = useRuntimeConfig()
  const wwwUrl = $config.public.wwwUrl

  const MARKETS_SECTIONS = [
    {
      name: 'Markets',
      columns: [
        {
          name: 'Upstream',
          children: [
            {
              name: 'Lithium',
              href: `${wwwUrl}/lithium`,
            },
            {
              name: 'Copper',
              href: `${wwwUrl}/copper`,
            },
            {
              name: 'Cobalt',
              href: `${wwwUrl}/cobalt`,
            },
            {
              name: 'Nickel',
              href: `${wwwUrl}/nickel`,
            },
            {
              name: 'Natural Graphite',
              href: `${wwwUrl}/natural-graphite`,
            },
            {
              name: 'Synthetic Graphite',
              href: `${wwwUrl}/synthetic-graphite`,
            },
            {
              name: 'Rare Earths',
              href: `${wwwUrl}/rare-earths`,
            },
            {
              name: 'Manganese',
              href: `${wwwUrl}/manganese`,
            },
            {
              name: 'Phosphate',
              href: `${wwwUrl}/phosphate`,
            },
            {
              name: 'Fluorspar',
              href: `${wwwUrl}/fluorspar`,
            },
          ],
        },
        {
          name: 'Midstream',
          children: [
            {
              name: 'Anode',
              href: `${wwwUrl}/anode`,
            },
            {
              name: 'Cathode',
              href: `${wwwUrl}/cathode`,
            },
            {
              name: 'Silicon Anode',
              href: `${wwwUrl}/silicon-anode`,
            },
          ],
        },
        {
          name: 'Downstream',
          children: [
            {
              name: 'Battery & Gigafactory',
              href: `${wwwUrl}/battery-gigafactory`,
            },
            {
              name: 'Recycling',
              href: `${wwwUrl}/recycling`,
            },
            {
              name: 'New Technology',
              href: `${wwwUrl}/new-technology`,
            },
            {
              name: 'EV Charging',
              href: `${wwwUrl}/ev-charging`,
            },
            {
              name: 'Portables',
              href: `${wwwUrl}/portables-service`,
            },
            {
              name: 'EV & Battery',
              href: `${wwwUrl}/ev-and-battery`,
            },
            {
              name: 'BESS',
              href: `${wwwUrl}/battery-energy-stationary-storage`,
            },
          ],
        },
      ],
    },
  ]

  const TOOLS_SECTIONS = [
    {
      name: 'Tools',
      children: [
        {
          name: 'Price Dashboard',
          href: `${wwwUrl}/price-dashboard`,
        },
        {
          name: 'Battery Emissions Analyser',
          href: `${wwwUrl}/battery-emissions-analyser`,
        },
        {
          name: 'Benchmark API',
          href: `${wwwUrl}/benchmark-api`,
        },
        {
          name: 'Excel Add In',
          href: `${wwwUrl}/excel-add-in`,
        },
        {
          name: 'Benchmark App',
          href: `${wwwUrl}/app`,
        },
      ],
    },
  ]

  const SERVICES_SECTIONS = [
    {
      name: 'Subscriptions',
      children: [
        {
          name: 'Price Assessments',
          href: `${wwwUrl}/price-assessments`,
        },
        {
          name: 'Supply Chain Data',
          href: `${wwwUrl}/supply-chain-data`,
        },
      ],
    },
    {
      name: 'Consultancy',
      children: [
        {
          name: 'Bespoke Studies',
          href: `${wwwUrl}/consultancy`,
        },
        {
          name: 'Life Cycle Assessments Consultancy ',
          href: `${wwwUrl}/lca`,
        },
      ],
    },
    {
      name: 'Industries',
      children: [
        {
          name: 'Find Your Sector',
          href: `${wwwUrl}/financial-services`,
        },
      ],
    },
  ]

  const WWW_DESKTOP_NAVIGATION: (TPopoverMenu | TLink)[] = [
    {
      name: 'Markets',
      menuId: 'markets',
      sections: MARKETS_SECTIONS,
      extraClass: 'xl:left-1/2',
    },
    {
      name: 'Services',
      menuId: 'services',
      sections: SERVICES_SECTIONS,
      extraClass: 'xl:left-1/2',
    },
    {
      name: 'Tools',
      menuId: 'tools',
      sections: TOOLS_SECTIONS,
    },
    {
      name: 'Plans',
      menuId: 'plans',
      href: `${wwwUrl}/plans`,
    },
    {
      name: 'Events',
      menuId: 'events',
      href: `${wwwUrl}/events`,
    },
    {
      name: 'Newsletters',
      menuId: 'newsletters',
      href: `${wwwUrl}/newsletters`,
    },
  ] as const

  const WWW_MOBILE_NAVIGATION = [
    {
      name: 'Markets',
      groups: MARKETS_SECTIONS[0].columns,
    },
    {
      name: 'Services',
      open: false,
      groups: SERVICES_SECTIONS,
    },
    {
      name: 'Tools',
      open: false,
      groups: TOOLS_SECTIONS[0].children,
    },
    {
      name: 'Plans',
      open: false,
      groups: [],
      href: `${wwwUrl}/plans`,
    },
    {
      name: 'Events',
      open: false,
      groups: [],
      href: `${wwwUrl}/events`,
    },
    {
      name: 'Newsletters',
      open: false,
      groups: [],
      href: `${wwwUrl}/newsletters`,
    },
  ]

  return {
    WWW_DESKTOP_NAVIGATION,
    WWW_MOBILE_NAVIGATION,
  }
}
